











































import Vue from 'vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import BottomButton from '@/components/BottomButton.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import { Toast } from '@/components/ds';
import AcademicFormationForm, {
  AcademicFormationFormEvent,
} from '@/components/forms/studentData/AcademicFormationForm.vue';
import pipeline from '@/pipeline';
import LoadingPage from '@/components/LoadingPage.vue';
import { formatStringToDate } from '@/helpers/formatters';
import i18n from '@/i18n';
import { AnalyticsActions } from '@/store/modules/analytics/actions';

const UNDERAGE_CUT_OFF_AGE = 18;

export default Vue.extend({
  components: {
    PipelineMenuWrapper,
    BackButton,
    BottomButton,
    AcademicFormationForm,
    ConfirmationModal,
    LoadingPage,
    Toast,
  },
  data() {
    return {
      form: {
        schoolCategory: this.$store.getters.academicFormation?.schoolCategory || '',
        year: this.$store.getters.academicFormation?.year || null,
        city: this.$store.getters.academicFormation?.city || '',
      } as AcademicFormationFormEvent,
      isModalActive: false,
      isLoading: false,
      error: false,
      errorMessage: '',
    };
  },
  computed: {
    isContinueEnabled(): boolean {
      return Object.values(this.form).every(Boolean) && !this.error;
    },
    name(): string {
      return this.$store.getters.studentFirstName || '';
    },
    partnerCode(): string {
      return this.$store.getters.partnerCode || '';
    },
  },
  methods: {
    async goToNextStep(hasFinancialSponsor: boolean) {
      try {
        this.isModalActive = false;
        this.isLoading = !hasFinancialSponsor;

        // TODO: We need this to create financialSponsor entity on backend. We should have a better validation :(
        const financialSponsor = hasFinancialSponsor ? {} : null;

        await this.$store.dispatch('UPSERT_ENROLLMENT', { financialSponsor });

        const academicFormation = this.form;
        await this.$store.dispatch('UPDATE_ACADEMIC_FORMATION', { academicFormation });

        if (!hasFinancialSponsor) {
          await this.$store.dispatch(AnalyticsActions.ENROLLMENT_DATA_SENT);
          if (this.partnerCode) {
            await this.applyVoucher();
            await this.generateContract();
          }
        }

        const target = hasFinancialSponsor ? 'financialSponsor' : 'documents';
        pipeline.next({ value: target });
      } catch (err) {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 3000);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },
    continueHandler() {
      const birthDate = formatStringToDate(this.$store.getters.personalData?.birthDate);

      if (!birthDate) {
        this.errorMessage = i18n.t('birthdayDateError');
        this.error = true;

        setTimeout(() => {
          this.error = false;
          this.errorMessage = '';
        }, 3000);
        return;
      }

      const today = new Date();

      const cutOffDate = new Date(
        today.getFullYear() - UNDERAGE_CUT_OFF_AGE,
        today.getMonth(),
        today.getDate(),
      );

      const isUnderage = birthDate.getTime() > cutOffDate.getTime();
      if (isUnderage) this.goToNextStep(true);
      else this.isModalActive = true;
    },
    inputHandler(event: AcademicFormationFormEvent) {
      this.form = event;
    },
    async applyVoucher() {
      await this.$store.dispatch('APPLY_VOUCHER', {
        voucher: this.partnerCode,
      });
    },
    async generateContract() {
      await this.$store.dispatch('GENERATE_CONTRACT');
    },
  },
});
